import helpers from '../../helpers';
import actionTypes from './constants';

/* */
const initialState = {
  contacts: null,
};

/* */
const defaultSort = (a, b) => {
  const isNewA = a.isNew || false;
  const isNewB = b.isNew || false;
  const fullnameA = `${a.lastname} ${a.firstname}`;
  const fullnameB = `${b.lastname} ${b.firstname}`;

  if (isNewA && !isNewB) return -1;
  if (!isNewA && isNewB) return 1;
  return fullnameA.localeCompare(fullnameB);
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTACTS_LIST: {
      const contacts = helpers.object.deepClone(action.payload);
      contacts.sort(defaultSort);
      return {
        ...state,
        contacts,
      };
    }
    case actionTypes.ADD_CONTACT: {
      const contacts = helpers.object.deepClone(state.contacts);
      contacts.push(action.payload);
      contacts.sort(defaultSort);
      return {
        ...state,
        contacts,
      };
    }
    case actionTypes.DELETE_CONTACT: {
      const contacts = state.contacts.filter((c) => c.uid !== action.payload.uid);
      contacts.sort(defaultSort);
      return {
        ...state,
        contacts,
      };
    }
    case actionTypes.UPDATE_CONTACT: {
      const contacts = state.contacts.filter((c) => c.uid !== action.payload.uid);
      contacts.push(action.payload);
      contacts.sort(defaultSort);
      return {
        ...state,
        contacts,
      };
    }
    default:
      return state;
  }
};
